import {AutocompleteModule, DatepickerModule} from "maps-angular-components";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CardsComponent} from './cards/cards.component';
import {CarteiraModule} from '../carteira/carteira.module';
import {CommonModule} from '@angular/common';
import {CountUpModule} from 'ngx-countup';
import {DashboardComponent} from './dashboard.component';
import {DesenquadradaComponent} from './consultas/desenquadrada/desenquadrada.component';
import {EnquadradaComponent} from './consultas/enquadrada/enquadrada.component';
import {EnquadradaFiltroComponent} from './consultas/enquadrada-filtro/enquadrada-filtro.component';
import { MatButtonModule } from "@angular/material/button";
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {NgModule} from '@angular/core';
import { PaginationMapsModule } from 'maps-angular-components';
import { PaginationModule } from 'ngx-bootstrap';
import {PanelHeaderComponent} from './panel-header/panel-header.component';
import {SharedModule} from '../shared/shared.module';
import { ProcessadaComponent } from './consultas/processada/processada.component';
import { NaoProcessadaComponent } from './consultas/nao-processada/nao-processada.component';
import { ComRegraComponent } from './consultas/com-regra/com-regra.component';
import { SemRegraComponent } from './consultas/sem-regra/sem-regra.component';
import { ComSemRegraFiltroComponent } from './consultas/com-sem-regra-filtro/com-sem-regra-filtro.component';
import { CanceladaComponent } from './consultas/cancelada/cancelada.component';

@NgModule({
    declarations: [
        DashboardComponent,
        PanelHeaderComponent,
        CardsComponent,
        EnquadradaComponent,
        EnquadradaFiltroComponent,
        DesenquadradaComponent,
        ProcessadaComponent,
        NaoProcessadaComponent,
        ComRegraComponent,
        SemRegraComponent,
        ComSemRegraFiltroComponent,
        CanceladaComponent
    ],
    exports: [
        DashboardComponent
    ],
    imports: [
        CommonModule,
        CountUpModule,
        SharedModule,
        BrowserAnimationsModule,
        PaginationModule,
        MatFormFieldModule,
        MatSelectModule,
        FormsModule,
        CarteiraModule,
        DatepickerModule,
        ReactiveFormsModule,
        PaginationMapsModule,
        AutocompleteModule,
        MatButtonModule,
        MatProgressBarModule,
        MatCardModule,
    ]
})
export class DashboardModule {
}
